export const validateNumber = (val) => {
  if (Number.isInteger(val)) return true;
  else return false;
};
